import { network } from 'services/network';

import { QueryParams } from 'api/queries/getMatrixData.query';

export const ENDPOINT = 'api/bo/getCardMatrixCountersData';

export const getCardMatrixCountersData = ({ versionId, numOfDaysToBeUrgent, filter }: QueryParams) => {
    const params = {
        metaDataId: versionId,
        numOfDaysToBeUrgent: numOfDaysToBeUrgent,
        filter,
    };
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
